import { Body } from '@shipt/design-system-typography'

export const ProductName = ({ name }: { name: string }) => {
  return (
    <Body as="h1" size="xl">
      {name}
    </Body>
  )
}
